import styles from "./index.module.css";

interface SkeletonProps extends React.ComponentProps<"div"> {
  height?: string;
  width?: string;
  absolute?: boolean;
  fitContent?: boolean;
}
const Skeleton = ({
  height,
  width = "100%",
  absolute,
  style,
  fitContent,
  ...rest
}: SkeletonProps) => {
  return (
    <div
      className={styles.skeleton}
      {...rest}
      style={{
        width,
        ...style,
        animation: "skeleton-loading 1s linear infinite alternate",
        height,
        position: absolute ? "absolute" : "relative",
        ...(fitContent && {
          width: "fit-content",
          height: "fit-content",
        }),
      }}
    />
  );
};

export default Skeleton;
